import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import { arrayOf, func, object, shape, string } from 'prop-types';
import Swatch from './swatch';
import { useStyle } from '@magento/venia-ui/lib/classify'; //'../../classify';

import defaultClasses from './swatchList.module.css';

var SwatchList = function SwatchList(props) {
  var getItemKey = props.getItemKey,
      _props$selectedValue = props.selectedValue,
      selectedValue = _props$selectedValue === void 0 ? {} : _props$selectedValue,
      items = props.items,
      onSelectionChange = props.onSelectionChange,
      disabledValuesMap = props.disabledValuesMap,
      defaultValue = props.defaultValue,
      attribute_id = props.attribute_id;
  var classes = useStyle(defaultClasses, props.classes);
  var swatches = useMemo(function () {
    var _items$map;

    var sortedItems = items === null || items === void 0 ? void 0 : (_items$map = items.map(function (item) {
      var _item$label, _item$label2, _item$label3;

      var start = item === null || item === void 0 ? void 0 : (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.indexOf('(');
      var end = item === null || item === void 0 ? void 0 : (_item$label2 = item.label) === null || _item$label2 === void 0 ? void 0 : _item$label2.indexOf(')');
      var result = item === null || item === void 0 ? void 0 : (_item$label3 = item.label) === null || _item$label3 === void 0 ? void 0 : _item$label3.substring(start + 1, end);
      return _objectSpread(_objectSpread({}, item), {}, {
        sortValue: result
      });
    })) === null || _items$map === void 0 ? void 0 : _items$map.sort(function (a, b) {
      if (a.sortValue > b.sortValue) {
        return 1;
      }

      if (a.sortValue < b.sortValue) {
        return -1;
      }

      return 0;
    });
    return sortedItems === null || sortedItems === void 0 ? void 0 : sortedItems.map(function (item) {
      var isSelected = item.label === selectedValue.label;
      var isDisabled = disabledValuesMap.get(item.value_index);
      return React.createElement(Swatch, {
        key: getItemKey(item),
        isSelected: isSelected,
        item: item,
        onClick: onSelectionChange // isDisabled={isDisabled}

      });
    });
  }, [getItemKey, selectedValue.label, items, onSelectionChange, disabledValuesMap]);
  var resetButton = useMemo(function () {
    var isDisabled = disabledValuesMap.get(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value_index);

    if (!(defaultValue !== null && defaultValue !== void 0 && defaultValue.value_index)) {
      return null;
    }

    return React.createElement(Swatch, {
      key: getItemKey(defaultValue) + '-reset',
      isSelected: false,
      item: defaultValue,
      onClick: onSelectionChange,
      isDisabled: isDisabled,
      isResetButton: true
    });
  });
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex-1",
    id: "scroll-swatch-".concat(attribute_id)
  }, React.createElement("div", {
    className: classes.wrap
  }, React.createElement("div", {
    className: "grid grid-cols-3 gap-1 md_gap-0 items-center pt-3 gap-y-5 ".concat(classes.selectedOptionsItem)
  }, swatches))), resetButton); // return <div className={classes.root}>{swatches}</div>;
};

SwatchList.propTypes = {
  classes: shape({
    root: string
  }),
  getItemKey: func,
  selectedValue: object,
  items: arrayOf(object),
  onSelectionChange: func
};
SwatchList.displayName = 'SwatchList';
export default SwatchList;